<template>
    <router-view />
</template>

<script>

export default {
    name: 'App'
}
</script>

<style lang="scss" scoped>
@import url("./style/main.scss");

#app {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>
